import { AccountSelect, useModalContentToggler } from '@components'

import { FormItem } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import {
  useMatch,
  useModalContentsOperations,
  useMultiplePayableSubjects,
  usePaymentModal,
} from '@features/paymentReconciliationModal/contexts'
import { SubjectReconciliationModalStateId } from '@features/paymentReconciliationModal/enums/SubjectReconciliationModalStateId'
import { Account } from '@modules-deprecated/app/accounts/types'

import { useSegment } from '../../../../../../hooks'

export const BillAccountSelector = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { activeState, setActiveState } = useModalContentToggler()
  const { selectedAccountId, setSelectedAccountId } = usePaymentModal()
  const { initialSubject, isCashBasis } = useMultiplePayableSubjects()
  const { resetValues } = useModalContentsOperations()
  const { matchSuggestion } = useMatch()
  const billId = initialSubject?.id

  const isMatchModalState = activeState === SubjectReconciliationModalStateId.Match
  const isBankLinesModalState = activeState === SubjectReconciliationModalStateId.BankLines

  const handleAccountChange = useCallback(
    (id?: string, value?: Account) => {
      if (!id || !billId) {
        return
      }

      resetValues()
      setSelectedAccountId(id)

      const event = isBankLinesModalState
        ? 'xxx - expenses - Bank line modal - account changed'
        : 'xxx - expenses - Manual payment modal - account changed'

      track(event)

      if (value?.isBankAccount === false || (isCashBasis && !isBankLinesModalState)) {
        return setActiveState(SubjectReconciliationModalStateId.ManualPayment)
      }

      if (value?.isBankAccount && value?.isPaymentEnabled) {
        setActiveState(SubjectReconciliationModalStateId.BankLines)
      }
    },
    [billId, isBankLinesModalState, resetValues, setActiveState, setSelectedAccountId, track, isCashBasis],
  )

  return (
    <FormItem label={t('account')}>
      <AccountSelect
        disabled={isMatchModalState}
        dropdownSize="fitTrigger"
        isPaymentEnabled
        onSelect={handleAccountChange}
        selectedId={isMatchModalState ? matchSuggestion?.account_id : selectedAccountId}
      />
    </FormItem>
  )
}
